import React from "react";
import DistributionsOptionsFormFields from "./DistributionsOptionsFormFields";
import DistributionAllocationMethodsFields from "./DistributionAllocationMethodsFields";
import FeesFields from "./FeesFields";
import { AddHierarchy } from "../../../components";
import SourceApplicableTable from "./SourceApplicableTable";

const QBADForm = (props) => {
  return (
    <div>
      <DistributionsOptionsFormFields {...props} />
      <SourceApplicableTable {...props} />
      <DistributionAllocationMethodsFields {...props} />
      <FeesFields {...props} />
      <AddHierarchy {...props} />
    </div>
  );
};

export default QBADForm;
